module.exports = __webpack_public_path__ + "static/img/Humphries.40c6f0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Humphries.jpg
// module id = TG/s
// module chunks = 0